import * as yup from "yup";
import "yup-phone";

export type InformationInputs = {
  name: string;
  telephone: string;
  fax: string;
  city: string;
  postal_code: string;
  address: string;
  lat: string;
  lng: string;
  is_priority: boolean;
};

export const informationSchema = yup.object().shape({
  name: yup.string().required(),
  telephone: yup.string().phone("ID", true).required().label("phone number"),
  fax: yup.string().label("fax number"),
  city: yup.string().required(),
  postal_code: yup
    .string()
    .matches(/^\d+$/, {
      message: "Postal Code must match number only",
    })
    .length(5)
    .required()
    .label("Postal Code"),
  lat: yup.string().required(),
  lng: yup.string().required(),
  address: yup.string(),
  is_priority: yup.boolean(),
});

export const InformationBaseModel: InformationInputs = {
  name: "",
  telephone: "",
  fax: "",
  city: "",
  postal_code: "",
  lat: "",
  lng: "",
  address: "",
  is_priority: false,
};
